<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Lịch sử gửi tin nhắn" :link="[{ text: 'Lịch sử gửi tin', href: '../post-history' }]" />
      </div>
    </div>
    <v-tabs v-model="tab" active-class="tab-active" class="mx-4" background-color="transparent">
      <v-tab class="tab-default" :key="1">APP</v-tab>
      <v-tab class="tab-default" :key="2">SMS</v-tab>
    </v-tabs>
    <v-card class="pa-6 mx-4 elevation-0" outlined>
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <AppHistory />
        </v-tab-item>
        <v-tab-item :key="2">
          <SmsHistory />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import AppHistory from '@/modules/post/AppHistory.vue'
import SmsHistory from '@/modules/post/SmsHistory.vue'

export default {
  components: {
    Breadcrumbs,
    AppHistory,
    SmsHistory
  },
  data() {
    return {
      tab: 0
    }
  }
}
</script>
